export default function (store, { $http }) {
  return {
    title: 'FindSourcing',
    description: 'Your guide to footwear sourcing!',
    image: 'https://www.findsourcing.com/storage/public/findsourcing.jpg',
  };
}
